import * as React from 'react';
import { SVGProps } from 'react';

const IconBoldSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.13 7.82c.83-.58 1.37-1.44 1.37-2.32C12.5 3.57 10.93 2 9 2H3v12h6.75c1.79 0 3.25-1.46 3.25-3.25 0-1.3-.77-2.41-1.87-2.93zM5.5 4h3.25c.83 0 1.5.67 1.5 1.5S9.58 7 8.75 7H5.5V4zm3.75 8H5.5V9h3.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z" />
  </svg>
);
export default IconBoldSizeS;
